module.exports = __webpack_public_path__ + "img/C08TechDivineOfferings_ua.cd804d9a.webp";